module.exports = __webpack_public_path__ + "llama-circle.db7ad83e6e1940c235d47b7fa6719e28.svg";